import {
  IFabricationProjectsState,
  IFabricationProjectResponse,
  IFabricationProject,
  Types
} from './types';
import { Reducer } from 'redux';

const INITIAL_STATE: IFabricationProjectsState = {
  projects: undefined,
  loading: false,
  error: false,
  contractNumber: undefined,
  needToRefreshProjects: false
};

type CustomAction = {
  type: Types;
  payload: {
    projectsResponse: IFabricationProjectResponse;
    selectedProjectId: number;
    project: IFabricationProject;
    contractNumber: string;
  };
};

const reducer: Reducer<IFabricationProjectsState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_FABRICATION_PROJECTS:
      return {
        ...INITIAL_STATE,
        projects: [],
        loading: true,
        error: false,
        contractNumber: action.payload.contractNumber,
        needToRefreshProjects: false
      };
    case Types.LOAD_FABRICATION_PROJECTS_SUCCESS:
      return {
        ...state,
        projects: action.payload.projectsResponse.projects,
        loading: false,
        error: false
      };
    case Types.LOAD_FABRICATION_PROJECTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };

    case Types.SET_NEED_TO_REFRESH_PROJECTS:
      return {
        ...state,
        needToRefreshProjects: true
      };

    default:
      return state;
  }
};

export default reducer;
